import { FC, memo } from 'react';
import { useLocation } from 'react-router-dom';
import { SideMenu } from './SideMenu';
import { useSideMenu } from '../../hooks/components/useSideMenu/useSideMenu';

const HIDDEN_ROUTES = new Set(['/login', '/register', '/logout']);

const AppSideMenuComponent: FC = () => {
  const { pathname } = useLocation();
  const { groups, activeKey } = useSideMenu();

  if (HIDDEN_ROUTES.has(pathname) || groups.length === 0) {
    return null;
  }

  return <SideMenu groups={groups} activeKey={activeKey} />;
};

export const AppSideMenu = memo(AppSideMenuComponent);
AppSideMenu.displayName = 'AppSideMenu';
